<style>
.v-carousel{width:100%;position:relative}
.v-carousel{overflow:hidden}
.v-carousel-items{overflow:hidden}
.v-carousel-dots{position:absolute;bottom:10px;left:0;width:100%;text-align:center}
.v-carousel-dot{cursor:pointer;display:inline-block;width:10px;height:10px;margin:0 5px;border-radius:5px;background:rgba(0,0,0,.5)}
.v-carousel-dot.active{background:#000;cursor:default}
.v-carousel-nav{cursor:pointer;position:absolute;line-height:30px;color:#fff;padding:0 5px;background:rgba(0,0,0,.5);top:50%;margin-top:-15px;display:none;}
.v-carousel-nav.prev{left:0}
.v-carousel-nav.next{right:0}
.v-carousel-item{width:100%;float:left}
</style>

<template lang="html">
  <div>
    <navbar></navbar>

    <div class="uk-margin-remove-top">
      <div class="uk-container">

        <div class="uk-grid uk-margin-right">
          <div>
            <a class="uk-navbar-item uk-logo" v-bind:href="logoLink">
              <img :src="config.logo_url" alt="Logo" style="height: 60px;" />
            </a>
          </div>
          <div style="margin-left: auto">

            <div class="uk-flex">
              <h3 class="uk-col" style="text-align: right;">
                <span class="uk-h6 uk-text-middle uk-visible@m" title="Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie." uk-tooltip="pos: bottom" style="cursor: help;">Witaj {{ firstName }} {{ LastName }}. Sesja wygaśnie za {{ sessionValidToText }}</span>
              </h3>
            </div>
            <div class="uk-flex">
              <router-link :to="{ name: 'main', params: {} }" class="uk-margin-auto-left">
                <button id="backbtn" class="uk-button uk-button-primary uk-button-small uk-margin-auto-left" style="float:left; display:none;">Wróć do listy wizyt</button>
              </router-link>
            </div>

          </div>
        </div>
        <hr class="uk-wdith uk-margin-remove-top uk-divider-icon">
      </div>
    </div>

    <div class="uk-container uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom page-wrapper">

      <div class="uk-width">

        <div class="uk-grid">
          <notifications class="uk-background-default"></notifications>

          <div class="uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap session-info-wrap">

            <div id="sliderMain">
              <carousel :auto="3000" :watch-items="list">
                <carousel-item v-for="(item, index) in list" :key="item.url">
                  <img v-bind:src="item.url" />
                </carousel-item>
              </carousel>
            </div>
          </div>
        </div>

        

        <router-view class="uk-width uk-background-default"></router-view>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import navbar from './Dashboard/navbar'
import leftmenu from './Dashboard/leftmenu'
import dashboardFooter from './Dashboard/footer'
import notifications from './Dashboard/notifications'
import UIkit from 'uikit'
import $ from 'jquery'
import { Carousel, CarouselItem } from 'vue-l-carousel'
var getDomain = location.protocol + '//' + location.host
export default {
  components: {
    navbar,
    leftmenu,
    dashboardFooter,
    notifications,
    'carousel': Carousel,
    'carousel-item': CarouselItem
  },
  beforeMount () {
    // Slider

    this.$http.post(getDomain + '/slider.php?number=1').then(response => {
      let images = Object.values(response.data).map(x => { return { url: `${getDomain}/slider1/${x}` } })
      this.list = images
    })
  },
  mounted () {
    var vm = this
    if (this.$cookie.get('aut')) {
      var refreshTokenMetod = {'input': {'status': '', 'data': {'TOKEN': this.$cookie.get('aut'), 'reservation_id': null}}}
      this.$http.post(getDomain + '/api.php?url=refreshToken', refreshTokenMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
        this.$cookie.set('aut', this.$cookie.get('aut'), { expires: '20m' })
      }).catch((errors) => {
        JSON.stringify(errors)
        vm.logout()
      })
    } else {
      this.$router.push({ path: '/' })
    }
    vm.setSessionTimer()
    $('.page-wrapper').click(vm.refreshSession)
    $('#logout_btn').click(vm.logoutBtn)
    $('#logout_btn_small').click(vm.logoutBtn)
    // if (this.$cookie.get('aut')) {
    //   if (this.$cookie.get('cdata')) {
    //     this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
    //     this.LastName = $.parseJSON(this.$cookie.get('cdata')).lastname
    //     this.email = $.parseJSON(this.$cookie.get('cdata')).email
    //   }
    // }
  },
  methods: {
    setSessionTimer () {
      var vm = this
      vm.sessionInterval = setInterval(timeout => {
        if (vm.sessionTime === 1) {
          UIkit.modal.alert('Użytkownik został wylogowany, ponieważ przez 20 minut nie została dokonana żadna czynność').then(closed => {
            vm.logout()
          })
        }
        vm.sessionTime--
      }, 100 * 600)
    },
    logout () {
      var vm = this
      vm.$cookie.delete('aut')
      localStorage.removeItem('unison_id')
      vm.$router.push({ path: '/' })
      window.clearInterval(vm.sessionInterval)
    },
    logoutBtn () {
      this.logout()
    },
    refreshSession () {
      this.sessionTime = 20
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var refreshTokenMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'reservation_id': null}}}
        this.$http.post(getDomain + '/api.php?url=refreshToken', refreshTokenMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          this.$cookie.set('aut', token, { expires: '20m' })
        }).catch((errors) => {
          JSON.stringify(errors)
        })
      }
    }
  },
  computed: {
    sessionValidToText () {
      var time = this.sessionTime
      var text

      switch (time) {
        case 4:
        case 3:
        case 2:
          text = 'minuty'
          break
        case 1:
          text = 'minutę'
          break
        default:
          text = 'minut'

      }
      return `${time} ${text}`
    },
    config () {
      return this.$parent.config
    },
    firstName () {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return $.parseJSON(this.$cookie.get('cdata')).name
        }
      }
    },
    LastName () {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return $.parseJSON(this.$cookie.get('cdata')).lastname
        }
      }
    },
    email () {
      if (this.$cookie.get('aut')) {
        if (this.$cookie.get('cdata')) {
          return $.parseJSON(this.$cookie.get('cdata')).email
        }
      }
    }
    // if (this.$cookie.get('aut')) {
    //   if (this.$cookie.get('cdata')) {
    //     this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
    //     this.LastName = $.parseJSON(this.$cookie.get('cdata')).lastname
    //     this.email = $.parseJSON(this.$cookie.get('cdata')).email
    //   }
    // }

  },
  data () {
    return {
      sessionTime: 20,
      // firstName: '',
      // LastName: '',
      // email: '',
      slider1: [
        {
          url: getDomain + '/slider1/slider_1_foto_1.jpg'
        }
      ],
      auto: 3000,
      // list: this.slider1
      list: []
    }
  }
}
</script>

<style lang="sass">

  .uk-card-badge
    background: #faa05a

</style>



// WEBPACK FOOTER //
// Dashboard.vue?5c74cc87